"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActionBannerSlots = exports.default = exports.ActionBanner = void 0;
var _components = require("@ori-ui/components");
var _icons = _interopRequireWildcard(require("@ori-ui/icons"));
var Icons = _icons;
var _mui = require("@ori-ui/mui");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _InfoIcon = _interopRequireDefault(require("../InfoIcon"));
var _actionBannerClasses = _interopRequireWildcard(require("./actionBannerClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getActionBannerSlots = ownerState => {
  const {
    disabled,
    isHovering
  } = ownerState;
  return {
    root: ['root', disabled && 'disabled'],
    content: ['content', isHovering && 'contentHover']
  };
};
exports.getActionBannerSlots = getActionBannerSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getActionBannerSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _actionBannerClasses.getActionBannerUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const ActionBannerRoot = (0, _mui.styled)(_mui.ButtonBase, {
  name: 'ActionBanner',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, ownerState.disabled && styles.disabled],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateColumns: '35px 1fr 24px',
  gap: 10,
  alignItems: 'center',
  padding: theme.spacing(4, 3),
  borderRadius: theme.shape.largeComponentRadius,
  background: theme.palette.common.white,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  border: '1px solid transparent',
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 6)
  },
  ...(ownerState.showBorder && {
    border: `1px solid ${theme.palette.grey[200]}`
  }),
  '&:hover': {
    backgroundColor: (0, _mui.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity),
    color: theme.palette.text.primary,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${_actionBannerClasses.default.disabled}`]: {
    color: theme.palette.action.disabled
  },
  [`&.${_actionBannerClasses.default.focusVisible}`]: {
    borderRadius: theme.shape.largeComponentRadius,
    outline: `2px solid ${theme.palette.default.dark}`,
    outlineOffset: -2
  }
}));
const ActionBannerContent = (0, _mui.styled)('span', {
  name: 'ActionBanner',
  slot: 'Content',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.content, ownerState.isHovering && styles.contentHover]
})(({
  theme,
  ownerState
}) => ({
  display: 'block',
  overflow: 'hidden',
  textAlign: 'left',
  color: theme.palette.text.primary,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  ...(ownerState.disabled && {
    color: theme.palette.action.disabled
  }),
  ...(ownerState.isHovering && {
    color: theme.palette.text.primary,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  })
}));
const ActionBanner = exports.ActionBanner = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'ActionBanner'
  });
  const {
    children,
    className,
    dataTestId,
    disabled = false,
    disableFocusRipple = false,
    iconName,
    showBorder = false,
    ...other
  } = props;
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const handleMouseOver = (0, _react.useCallback)(() => {
    setIsHovering(true);
  }, []);
  const handleMouseOut = (0, _react.useCallback)(() => {
    setIsHovering(false);
  }, []);
  const ownerState = {
    ...props,
    disabled,
    isHovering,
    showBorder
  };
  const infoIcon = (0, _react.useMemo)(() => {
    if (typeof iconName === 'string') {
      const IconComponent = Icons[iconName];
      if (IconComponent) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
          fontSize: "inherit"
        });
      }
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTagFilled, {
      fontSize: "inherit"
    });
  }, [iconName]);
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ActionBannerRoot, {
    ref: ref,
    centerRipple: true,
    className: (0, _clsx.default)(classes.root, className),
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    "data-testid": dataTestId,
    ownerState: ownerState,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    ...other,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoIcon.default, {
      children: infoIcon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionBannerContent, {
      ownerState: ownerState,
      className: (0, _clsx.default)(classes.content, isHovering && classes.contentHover),
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {
      fontSize: "medium"
    })]
  });
});
var _default = exports.default = ActionBanner;
